import styles from "./PreviewSubmission.module.css";
import { formatDate } from "../../../../utilities/formatUtilities";
import { isMomentObject } from "../../../../utilities/dateUtilities";

function PreviewSubmission({ formData }) {
  const handleValue = (field) => {
    const value = field.value;
    if (value === true) {
      return "Yes";
    } else if (value === false) {
      return "No";
    } else if (field.masked !== undefined) {
      return "*".repeat(field.value?.length);
    } else if (isMomentObject(value)) {
      return formatDate(value);
    }
    return value;
  };

  const renderItem = (field) => (
    <div key={field.fieldName} className={styles.infoRow}>
      <span className={styles.label}>{field.label}</span>
      <span>{handleValue(field)}</span>
    </div>
  );

  return (
    <section className={styles.container}>
      <h2>Claim Summary</h2>
      {formData.map(
        (item) =>
          item && (
            <div key={item.heading}>
              <div className={styles.headingRow}>
                <h3 className={styles.heading}>{item.heading}</h3>
                {item.edit && (
                  <button
                    className={styles.editLink}
                    onClick={(event) => {
                      event.preventDefault();
                      item.edit();
                    }}
                    aria-label={`Edit ${item.heading}`}
                  >
                    Edit
                  </button>
                )}
              </div>
              <hr className={styles.line}></hr>
              <div className={styles.section}>
                {Array.isArray(item.fields[0]) ? (
                  <ol className={styles.orderedList}>
                    {item.fields.map((field, index) => (
                      <li key={index}>
                        {field.map((item) => renderItem(item))}
                      </li>
                    ))}
                  </ol>
                ) : (
                  item.fields.map((field) => renderItem(field))
                )}
              </div>
            </div>
          )
      )}
    </section>
  );
}

export default PreviewSubmission;
